document.addEventListener("DOMContentLoaded", () => {
  const THRESHOLD = 25000; // dollars
  const BUFFER_MS = 30 * 1000; // 30 seconds
  const STORAGE_KEY = "cartThresholdLastDismissedAt";

  const modal = document.getElementById("inventory-threshold-notice");
  const closeBtn = document.getElementById("inventory-threshold-close");
  const okBtn = document.getElementById("inventory-threshold-ok"); // optional

  if (!modal) return;

  const show = () => { modal.style.display = "block"; };
  const hide = () => {
    modal.style.display = "none";
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {}
  };

  closeBtn?.addEventListener("click", hide);
  okBtn?.addEventListener("click", hide);
  modal.addEventListener("click", (e) => { if (e.target === modal) hide(); });

  const withinBuffer = () => {
    try {
      const last = Number(localStorage.getItem(STORAGE_KEY));
      return Number.isFinite(last) && (Date.now() - last) < BUFFER_MS;
    } catch {
      return false;
    }
  };

  const centsToDollars = (cents) => (Number(cents) || 0) / 100;

  const checkCart = async () => {
    try {
      const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
      if (!res.ok) return;
      const cart = await res.json();

      const total = centsToDollars(cart.total_price);

      if (total >= THRESHOLD) {
        if (!withinBuffer()) show();
      } else {
        modal.style.display = "none";
      }
    } catch {
      // fail silently
    }
  };

  // Run immediately on load
  checkCart();

  // --- Hook into AJAX cart activity (fetch + XHR) ---
  const isCartEndpoint = (url) => {
    const u = String(url || "");
    return (
      u.includes("/cart/add") ||
      u.includes("/cart/change") ||
      u.includes("/cart/update") ||
      u.includes("/cart/clear") ||
      u.includes("/cart.js") ||
      u.includes("/cart.json")
    );
  };

  // Hook fetch
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    try {
      const url = args?.[0];
      if (isCartEndpoint(url)) setTimeout(checkCart, 150);
    } catch {}
    return response;
  };

  // Hook XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.___cartUrl = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    this.addEventListener("loadend", () => {
      try {
        if (isCartEndpoint(this.___cartUrl)) setTimeout(checkCart, 150);
      } catch {}
    });
    return originalSend.call(this, body);
  };

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) checkCart();
  });
});
